import { useId, useMemo } from "react";
import { scopeSvgIds } from "./svg-scope.ts";

// The ONE way an SVG slide gets into the page — player, content card, editor
// preview, bulk-compose grid. Same reasoning as TextSlideView: four copies of
// `dangerouslySetInnerHTML` drifted apart, and only one of them had thought
// about what happens when two slides share the document.
//
// Every instance gets its own id namespace (see svg-scope.ts), so a gradient
// named `#bg` in one slide can never paint another slide.
export default function InlineSvg({
  svg,
  className = "",
}: {
  svg: string;
  className?: string;
}) {
  // Stable for the life of this instance, and distinct from every other
  // instance — which is exactly the scope an id namespace needs.
  const scope = useId();
  const scoped = useMemo(() => scopeSvgIds(svg, scope), [svg, scope]);
  return <div className={className} dangerouslySetInnerHTML={{ __html: scoped }} />;
}
